import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import * as styles from './copyright.module.scss';

const Copyright = () => {
	const site = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						legalSubject
					}
				}
			}
		`
	)?.site?.siteMetadata;

	return <div className={styles.copyright}>{site?.legalSubject} &copy; Všechna práva vyhrazena.</div>;
};

export default Copyright;
